import React from "react";

interface ViewProps {
  fileSource: string;
}

const ViewSignature: React.FC<ViewProps> = ({ fileSource }) => {
  return (
    <div className="mt-3">
      {fileSource?.length > 0 && (
        <img
          src={fileSource}
          alt="applicant-signature"
          // width={140}
          // height={50}
          style={{ maxWidth: "max-content", maxHeight: 55 }}
          className="object-fit-cover"
        />
      )}
    </div>
  );
};

export default ViewSignature;
